export enum AciDeliverySessionType {
    LABOLOGY = 'Labology',
    SPOTLIGHT = 'Spotlight',
    FOCUS = 'Focus',
    WEEKLY_STANDUP = 'Weekly Standup',
    LEVEL_UP = 'Level Up',
    CAREER_SERVICES = 'Career Services',
}

export const ACI_PROGRAM_NAME = 'AWS Cloud Institute';

export const ACTIVITY_GROUP_NAME_EMBEDDED_VALUE_DELIMITER = '##';
